import { ADDRESS_STATUS, REQUIRED_FIELDS } from './constants';

export const isAddressComplete = address =>
  REQUIRED_FIELDS.every(field => !!(address || {})[field]);

export const isAddressForced = address =>
  (address || {}).status === ADDRESS_STATUS.FORCED;
